import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { FeatureDiscoveryQuery } from '@confluence/feature-discovery/entry-points/FeatureDiscoveryQuery.ts';

export const preloadFeatureDiscovery = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: FeatureDiscoveryQuery,
	});
};
